import {ServiceBase} from "../ServiceBase";
import {StickyHandler} from "../../components/sticky-handler/sticky-handler";
import {IStickyHandler} from "../../components/sticky-handler/sticky-handler.interface";

export class StickyHandlerFactoryService extends ServiceBase{

  createStickyHandler(): IStickyHandler{
    return new StickyHandler(this.services);
  }

}
